import { Navigate } from 'react-router-dom'

import { useViewer } from '~/Viewer'

import s from './You.module.css'

/**
 * Your own page, under whichever name you reached for.
 *
 * Three addresses meant it and they did not agree. `/u/<you>` is the page. `/you` was a
 * strictly smaller one — your name, your handle and the friends list, with the record, the
 * figures and everything else missing — that only a typed address ever reached, because the
 * masthead had pointed at `/u/<you>` since there was a profile to point at. And `/profile`,
 * the name somebody would actually guess, was not a route at all: signed in it answered
 * `{"error":"no"}` as text in the browser, and signed out it bounced through a login whose
 * `next` then delivered the same thing.
 *
 * So this is a signpost rather than a page. One profile, three ways in.
 */
export function You() {
  const me = useViewer()

  // `undefined` is "the answer is in flight", which is not the same as "nobody is signed
  // in" — the bar has been through this once already and said "Sign in" to somebody who
  // was signed in. Drawing nothing is the honest state.
  if (me === undefined) return <main className={s.wrap} aria-busy="true" />

  if (me === null) {
    return (
      <main className={s.wrap}>
        <h1 className={s.name}>Not signed in</h1>
        <p className={s.blurb}>
          <a href="/login">Sign in</a> to keep a list and see what your friends are going to.
        </p>
      </main>
    )
  }

  // `replace`, so Back goes where they came from rather than to the address that sent them
  // straight here again.
  return <Navigate to={`/u/${me.username}`} replace />
}
